/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class RequestResetPassword extends PageStringSection {
    button_resetPassword_label: string = "Labels.lbl_ResetPassword";
    error_emailInvalid: string = "Messages.msg_EmailInvalid";
    error_emailRequired: string = "Messages.msg_EmailRequired";
    error_emailNotConfirmed: string = "Messages.msg_EmailNotConfirmed";
    error_SomethingWentWrong: string = "Something went wrong. Please try again or contact your Administrator.";
    formItem_email_label: string = "Labels.lbl_Email";
    formItem_email_placeholder: string = "Labels.lbl_Email";
    heading_resetPassword: string = "Labels.lbl_ResetPassword";
    link_backToSignIn_label: string = "Labels.lbl_BackToSignIn";
    success_emailSent: string = "Messages.msg_EmailSent";
}
